export type BoxMovementStatus = "idle" | "loading" | "undoing";
export type BoxMovementInputValue = string | number;

interface BuildSupplierBoxMovementDisplayInput {
  addReceived: BoxMovementInputValue;
  addSent: BoxMovementInputValue;
  boxBalance: number;
  readOnly: boolean;
  status: BoxMovementStatus;
}

export function parseBoxMovementInput(value: string): BoxMovementInputValue {
  if (value === "") return "";
  return Math.max(0, parseInt(value) || 0);
}

function getBoxMovementValue(value: BoxMovementInputValue): number {
  return value === "" ? 0 : Number(value);
}

export function formatSupplierBoxAction(received: number, sent: number) {
  const parts: string[] = [];
  if (received > 0) {
    parts.push(`+${received} recebidas`);
  }
  if (sent > 0) {
    parts.push(`+${sent} enviadas`);
  }
  return parts.join(" / ");
}

export function buildBoxMovementPayload(
  action: "receive" | "send",
  quantity: number,
) {
  return action === "receive"
    ? { boxesSent: 0, boxesReceived: quantity }
    : { boxesSent: quantity, boxesReceived: 0 };
}

export function formatLatestBoxMovement(movement: SupplierBoxMovement) {
  const action = movement.operation === "CREDIT" ? "recebidas" : "enviadas";
  const time = new Intl.DateTimeFormat("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "America/Sao_Paulo",
  }).format(new Date(movement.created_at));
  return `+${movement.quantity} ${action} · ${time}`;
}

export function buildSupplierBoxMovementDisplay({
  addReceived,
  addSent,
  boxBalance,
  readOnly,
  status,
}: BuildSupplierBoxMovementDisplayInput) {
  const currentAddReceived = getBoxMovementValue(addReceived);
  const currentAddSent = getBoxMovementValue(addSent);
  const isPristine = currentAddSent === 0 && currentAddReceived === 0;
  const isBusy = status === "loading" || status === "undoing";
  const isDisabled = readOnly || isPristine || isBusy;
  const canEdit = !readOnly;
  const balanceColor = boxBalance >= 0 ? "#16a34a" : "#ef4444";

  return {
    currentAddReceived,
    currentAddSent,
    isPristine,
    isBusy,
    isDisabled,
    canEdit,
    balanceColor,
  };
}
import type { SupplierBoxMovement } from "./types";
